import React from "react";

const CustomInput = ({
  label,
  type = "text",
  id,
  register,
  errors,
  validation = {},
  placeholder = "",
  required = true,
}) => {
  return (
    <div>
      <label htmlFor={id} className="block text-sm font-medium mb-2">
        {label} {required ? <span className="text-red-500">*</span> : <></>}
      </label>
      <div className="relative">
        <input
          type={type}
          id={id}
          {...register(id, {
            required: `${label} est obligatoire`,
            ...validation,
          })}
          placeholder={placeholder}
          className={`py-3 px-4 block w-full border ${
            errors[id] ? "border-red-500" : "border-gray-300"
          } rounded-lg text-sm focus:border-${
            errors[id] ? "red" : "gray"
          }-500 focus:ring-${errors[id] ? "red" : "gray"}-500`}
          aria-describedby={`${id}-helper`}
        />
        {errors[id] && (
          <div className="absolute inset-y-0 end-0 flex items-center pointer-events-none pe-3">
            <svg
              className="shrink-0 size-4 text-red-500"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" x2="12" y1="8" y2="12"></line>
              <line x1="12" x2="12.01" y1="16" y2="16"></line>
            </svg>
          </div>
        )}
      </div>
      <p className="text-sm text-red-600 mt-2" id={`${id}-helper`}>
        {errors[id] ? errors[id].message : ""}
      </p>
    </div>
  );
};

export default CustomInput;
